import { render, staticRenderFns } from "./QuickReply.vue?vue&type=template&id=737c98cc&scoped=true&"
import script from "./QuickReply.vue?vue&type=script&lang=js&"
export * from "./QuickReply.vue?vue&type=script&lang=js&"
import style0 from "./QuickReply.vue?vue&type=style&index=0&id=737c98cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737c98cc",
  null
  
)

export default component.exports